<h1 mat-dialog-title class="dialog-confirm-responsible-title">Atenção!</h1>

<form name="formCheckout" [formGroup]="responsibleForm" (ngSubmit)="onHandleSubmit()">
    <div mat-dialog-content>
        <div class="dialog-confirm-responsible-container">
            <span class="dialog-confirm-responsible-text">Não conseguimos salvar os dados do responsável. Informe-os novamente por
                favor!</span>

            <div class="row mb-2 mt-3">
                <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome</mat-label>
                        <input matInput placeholder="José" formControlName="nome">
                        <mat-error>Este campo é obrigatório</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Sobrenome</mat-label>
                        <input matInput placeholder="Silva" formControlName="sobrenome">
                        <mat-error>Este campo é obrigatório</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                    <mat-form-field appearance="outline">
                        <mat-label>E-mail</mat-label>
                        <input matInput placeholder="seunome@email.com" formControlName="email">
                        <mat-error>Este campo é obrigatório</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Celular</mat-label>
                        <input matInput ng2TelInput [ng2TelInputOptions]="ng2TelInputOptions" (countryChange)="onCountryChange($event)" (intlTelInputObject)="onTelInputMount($event)"
                            [placeholder]="phone.sigla == 'br' ? '(00) 0 0000-0000' :
                            'Celular'" [mask]="phone.sigla == 'br' ? '(00) 0000-0000 || (00) 0 0000-0000' : '0000000000000000'"
                            formControlName="telefone" [validation]="phone.sigla == 'br'">
                        <mat-error>Este campo é obrigatório</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <ng-container *ngIf="showResponsibleAddress">
                <div class="row mb-2 mt-3">
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Cep</mat-label>
                            <input
                                matInput
                                placeholder="00000-000"
                                mask="X*"
                                [patterns]="zipCodePattern"
                                formControlName="cep"
                                (change)="onCepChange()"
                            >
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Endereço</mat-label>
                            <input matInput placeholder="Av. Paulista" formControlName="endereco">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-2 mt-3">
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Bairro</mat-label>
                            <input matInput placeholder="Centro" formControlName="bairro">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Cidade</mat-label>
                            <input matInput placeholder="São Paulo" formControlName="cidade">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-2 mt-3">
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="999" formControlName="numero">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Complemento</mat-label>
                            <input matInput placeholder="Apt. 005" formControlName="complemento">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-2 mt-3">
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Estado</mat-label>
                            <input matInput placeholder="São Paulo" formControlName="estado">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-sm-6 col-lg-6 col-xl-6">
                        <mat-form-field appearance="outline">
                            <mat-label>País</mat-label>
                            <input matInput placeholder="Brasil" formControlName="pais">
                            <mat-error>Este campo é obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>

    <div mat-dialog-actions class="action-form-purchase">
        <button mat-button class="dialog-confirm-responsible-actions-confirm">finalizar</button>
    </div>
</form>
